import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const gigs = [
  { date: "SEP 12", year: "2026", city: "MIAMI, FL", venue: "BASEMENT 9", status: "TICKETS" },
  { date: "OCT 03", year: "2026", city: "ORLANDO, FL", venue: "THE FOUNDRY", status: "TICKETS" },
  { date: "OCT 31", year: "2026", city: "ATLANTA, GA", venue: "WAREHOUSE 5 — HALLOWEEN", status: "SOON" },
  { date: "NOV 21", year: "2026", city: "TAMPA, FL", venue: "SIGNAL FEST", status: "SOON" },
  { date: "DEC 31", year: "2026", city: "MIAMI, FL", venue: "NYE — LOCATION TBA", status: "LOCKED" },
];

export default function Events() {
  return (
    <section id="events" data-testid="events-section" className="border-b border-white/15">
      <div className="px-4 sm:px-8 py-20 sm:py-28">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-mono-x text-[11px] tracking-[0.3em] text-white/40 uppercase mb-4"
              data-testid="events-overline"
            >
              [04] — TRANSMISSIONS
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="font-mono-x font-extrabold uppercase tracking-tighter leading-[0.9] text-4xl sm:text-6xl"
              data-testid="events-title"
            >
              WHERE THE
              <br />
              <span className="text-stroke">COLONY PLAYS</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-xs font-mono-x text-[11px] leading-relaxed tracking-wider text-white/50 uppercase"
            data-testid="events-description"
          >
            Upcoming sets. Doors late, lights never on. Want the colony in your city? Transmit a
            booking request.
          </motion.p>
        </div>

        <div className="border-t border-l border-white/15" data-testid="events-list">
          {gigs.map((g, i) => (
            <motion.div
              key={`${g.date}-${g.venue}`}
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-[auto_1fr_auto] sm:grid-cols-[140px_1fr_1fr_auto] items-center gap-x-6 gap-y-1 border-r border-b border-white/15 px-5 sm:px-8 py-6 hover:bg-white transition-colors duration-200 cursor-pointer"
              data-testid={`event-row-${i}`}
            >
              <div className="font-mono-x">
                <span className="block text-2xl sm:text-3xl font-extrabold tracking-tighter group-hover:text-black transition-colors duration-200">
                  {g.date}
                </span>
                <span className="block text-[10px] tracking-[0.3em] text-white/40 group-hover:text-black/50 transition-colors duration-200">
                  {g.year}
                </span>
              </div>
              <div className="font-mono-x text-sm sm:text-base font-bold uppercase tracking-tight group-hover:text-black transition-colors duration-200">
                {g.city}
              </div>
              <div className="col-span-2 sm:col-span-1 font-mono-x text-xs sm:text-sm tracking-wider text-white/50 uppercase group-hover:text-black/60 transition-colors duration-200">
                {g.venue}
              </div>
              <span
                className={`inline-flex items-center gap-2 font-mono-x text-[10px] tracking-[0.25em] px-3 py-2 border transition-colors duration-200 ${
                  g.status === "TICKETS"
                    ? "border-[#ff3b1d] text-[#ff3b1d]"
                    : "border-white/20 text-white/50 group-hover:border-black/30 group-hover:text-black/60"
                }`}
                data-testid={`event-status-${i}`}
              >
                {g.status} <ArrowUpRight size={11} />
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
